import { adminPage } from '../../composables/useAdminPanel.js'

// The shell shows the original panel or admin-v2 (chosen per browser). Pages wrapped in adminPage()
// have an admin-v2 version; the others look the same in both panels.
export default [
  {
    path: '/admin',
    component: () => import('../../layouts/AdminShell.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    },
    children: [
      {
        path: '',
        name: 'admin.dashboard',
        component: adminPage(
          () => import('../../views/admin/DashboardView.vue'),
          () => import('../../views/admin-v2/DashboardView.vue'),
        ),
        meta: {
          title: 'Dashboard - Admin Panel'
        }
      },
      {
        path: 'products',
        name: 'admin.products',
        component: adminPage(
          () => import('../../views/admin/ProductsView.vue'),
          () => import('../../views/admin-v2/ProductsView.vue'),
        ),
        meta: {
          title: 'Produkty - Admin Panel'
        }
      },
      {
        path: 'products/gallery',
        name: 'admin.products.gallery',
        component: adminPage(
          () => import('../../views/admin/ProductGalleryView.vue'),
          () => import('../../views/admin-v2/GalleryView.vue'),
        ),
        meta: {
          title: 'Galéria obrázkov - Admin Panel'
        }
      },
      {
        path: 'orders',
        name: 'admin.orders',
        component: adminPage(
          () => import('../../views/admin/OrdersView.vue'),
          () => import('../../views/admin-v2/OrdersView.vue'),
        ),
        meta: {
          title: 'Objednávky - Admin Panel'
        }
      },
      {
        path: 'orders/:id',
        name: 'admin.orders.detail',
        component: adminPage(
          () => import('../../views/admin/OrderDetailView.vue'),
          () => import('../../views/admin-v2/OrderDetailView.vue'),
        ),
        meta: {
          title: 'Detail objednávky - Admin Panel'
        }
      },
      {
        path: 'users',
        name: 'admin.users',
        component: adminPage(
          () => import('../../views/admin/UsersView.vue'),
          () => import('../../views/admin-v2/UsersView.vue'),
        ),
        meta: {
          title: 'Používatelia - Admin Panel'
        }
      },
      {
        path: 'categories',
        name: 'admin.categories',
        component: adminPage(
          () => import('../../views/admin/CategoriesView.vue'),
          () => import('../../views/admin-v2/CategoriesView.vue'),
        ),
        meta: {
          title: 'Kategórie - Admin Panel'
        }
      },
      {
        path: 'discounts',
        name: 'admin.discounts',
        component: adminPage(
          () => import('../../views/admin/DiscountsView.vue'),
          () => import('../../views/admin-v2/DiscountsView.vue'),
        ),
        meta: {
          title: 'Zľavy - Admin Panel'
        }
      },
      {
        path: 'custom-pricing',
        name: 'admin.custom-pricing',
        component: adminPage(
          () => import('../../views/admin/CustomPricing.vue'),
          () => import('../../views/admin-v2/CustomPricingView.vue'),
        ),
        meta: {
          feature: 'b2b',
          title: 'Individuálne ceny - Admin Panel'
        }
      },
      {
        path: 'marketing',
        name: 'admin.marketing',
        component: () => import('../../views/admin/MarketingStatsView.vue'),
        meta: {
          feature: 'telemarketing',
          title: 'Marketingové štatistiky - Admin Panel'
        }
      },
      {
        path: 'referral-codes',
        name: 'admin.referral-codes',
        component: () => import('../../views/admin/ReferralCodesView.vue'),
        meta: {
          feature: 'referrals',
          title: 'Referenčné kódy - Admin Panel'
        }
      },
      {
        path: 'rewards',
        name: 'admin.rewards',
        component: adminPage(
          () => import('../../views/admin/RewardsView.vue'),
          () => import('../../views/admin-v2/RewardsView.vue'),
        ),
        meta: {
          feature: 'rewards',
          title: 'Odmeny - Admin Panel'
        }
      },
      {
        path: 'shipping',
        name: 'admin.shipping',
        component: adminPage(
          () => import('../../views/admin/ShippingView.vue'),
          () => import('../../views/admin-v2/ShippingView.vue'),
        ),
        meta: {
          title: 'Doprava - Admin Panel'
        }
      },
      {
        path: 'payments',
        name: 'admin.payments',
        component: adminPage(
          () => import('../../views/admin/PaymentsView.vue'),
          () => import('../../views/admin-v2/PaymentsView.vue'),
        ),
        meta: {
          title: 'Platby - Admin Panel'
        }
      },
      {
        path: 'analytics',
        name: 'admin.analytics',
        component: adminPage(
          () => import('../../views/admin/AnalyticsView.vue'),
          () => import('../../views/admin-v2/AnalyticsView.vue'),
        ),
        meta: {
          title: 'Štatistiky - Admin Panel'
        }
      },
      {
        // Admin v2 only (no page in the original panel)
        path: 'product-sales',
        name: 'admin.product-sales',
        component: () => import('../../views/admin-v2/ProductSalesView.vue'),
        meta: {
          title: 'Predaj produktov - Admin Panel'
        }
      },
      {
        // Admin v2 only: base spices and packages of the custom spice mix builder
        path: 'mix-builder',
        name: 'admin.mix-builder',
        component: () => import('../../views/admin-v2/MixBuilderView.vue'),
        meta: {
          feature: 'mixBuilder',
          title: 'Vlastné zmesi - Admin Panel'
        }
      },
      {
        // Admin v2 only: maintenance page, launch countdown, orders only for registered customers
        path: 'settings',
        name: 'admin.settings',
        component: () => import('../../views/admin-v2/ShopSettingsView.vue'),
        meta: {
          title: 'Nastavenia - Admin Panel'
        }
      },
      {
        // Admin v2 only: texts, preview and test of the shop's e-mails
        path: 'emails',
        name: 'admin.emails',
        component: () => import('../../views/admin-v2/EmailTemplatesView.vue'),
        meta: {
          title: 'E-maily - Admin Panel'
        }
      },
      {
        path: 'auditlog',
        name: 'admin.auditlog',
        component: adminPage(
          () => import('../../views/admin/AuditLogsView.vue'),
          () => import('../../views/admin-v2/AuditLogView.vue'),
        ),
        meta: {
          title: 'Audit log - Admin Panel'
        }
      },
      {
        path: 'email-logs',
        name: 'admin.email-logs',
        component: adminPage(
          () => import('../../views/admin/EmailLogsView.vue'),
          () => import('../../views/admin-v2/EmailLogsView.vue'),
        ),
        meta: {
          title: 'Email Logy - Admin Panel'
        }
      },
      {
        path: 'checkout-flow',
        name: 'admin.checkout-flow',
        component: adminPage(
          () => import('../../views/admin/CheckoutFlowView.vue'),
          () => import('../../views/admin-v2/CheckoutFlowView.vue'),
        ),
        meta: {
          title: 'Checkout Flow - Admin Panel'
        }
      },
      {
        path: 'order-closures',
        name: 'admin.order-closures',
        component: adminPage(
          () => import('../../views/admin/OrderClosuresView.vue'),
          () => import('../../views/admin-v2/OrderClosuresView.vue'),
        ),
        meta: {
          title: 'Uzávierka objednávok - Admin Panel'
        }
      },
      {
        path: 'purchase-prices',
        name: 'admin.purchase-prices',
        component: adminPage(
          () => import('../../views/admin/ProductPurchasePricesView.vue'),
          () => import('../../views/admin-v2/PurchasePricesView.vue'),
        ),
        meta: {
          title: 'Nákupné ceny - Admin Panel'
        }
      },
      {
        path: 'order-closure-stats',
        name: 'admin.order-closure-stats',
        component: adminPage(
          () => import('../../views/admin/OrderClosureStatsView.vue'),
          () => import('../../views/admin-v2/OrderClosureStatsView.vue'),
        ),
        meta: {
          title: 'Štatistiky uzávierok - Admin Panel'
        }
      },
      {
        path: 'tablet',
        name: 'admin.tablet',
        component: adminPage(
          () => import('../../views/admin/TabletView.vue'),
          () => import('../../views/admin-v2/PackingView.vue'),
        ),
        meta: {
          title: 'Expedičný sprievodca - Admin Panel'
        }
      },
      {
        path: 'product-sets',
        name: 'admin.product-sets',
        component: adminPage(
          () => import('../../views/admin/ProductSetsView.vue'),
          () => import('../../views/admin-v2/ProductSetsView.vue'),
        ),
        meta: {
          feature: 'productSets',
          title: 'Sety produktov - Admin Panel'
        }
      },
      {
        path: 'messages/:id?',
        name: 'admin.messages',
        component: adminPage(
          () => import('../../views/admin/ChatView.vue'),
          () => import('../../views/admin-v2/ChatView.vue'),
        ),
        meta: {
          feature: 'chat',
          title: 'Správy - Admin Panel'
        }
      },
      {
        path: 'guide',
        name: 'admin.guide',
        component: adminPage(
          () => import('../../views/admin/GuideView.vue'),
          () => import('../../views/admin-v2/GuideView.vue'),
        ),
        meta: {
          feature: 'guide',
          title: 'Sprievodca - Admin Panel'
        }
      },
      {
        path: 'spice-mixes',
        name: 'admin.spice-mixes',
        component: adminPage(
          () => import('../../views/admin/SpiceMixesView.vue'),
          () => import('../../views/admin-v2/SpiceMixesView.vue'),
        ),
        meta: {
          feature: 'spiceMixes',
          title: 'Zmesi korenín - Admin Panel'
        }
      },
      {
        path: 'minigame',
        name: 'admin.minigame',
        component: adminPage(
          () => import('../../views/admin/MinigameView.vue'),
          () => import('../../views/admin-v2/MinigameView.vue'),
        ),
        meta: {
          feature: 'flappy',
          title: 'Minihra - Admin Panel'
        }
      }
    ]
  }
]
